//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Models

import { Enums } from '../../../../models/common'
import { OpDescr } from '../../../../../app/models/core'
import { Dictionary } from '../../../../../app/helpers'
import { IReferenceType } from '../../../../../app/models/util/interfaces'
import { OpInstallationCategory } from '../../../../models/custom/op-installation-category'
// import { OpReferenceTypeObject } from '../../../../models/custom'

//#endregion

//#region Service Imports

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'

//#endregion

// #region Consts

export const KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME: string = 'KingspanConfigurationFormService'
export const KINGSPAN_CONFIGURATION_FORM_SERVICE_PROVIDER_NAME: string = 'KingspanConfigurationFormServiceProvider'

export const idCustromInstallationCategory: number = 15744
const idCommonInstallationCategoryMin: number = 15740
const idCommonInstallationCategoryMax: number = 15849

const idCommonUdiDescriptionMin: number = 16010
const idCommonUdiDescriptionMax: number = 16099

// export enum KingspnaAlarms { //number is proper idDescr
//     HighLevelAlarm = 16010,
//     LossOfPower = 16011,
//     Pump1Tripped = 16012,
//     Pump2Tripped = 16013,
//     CommonAlarm = 16014,
//     CustomAlarmDetails = 16015,
//     LossOfRotation = 16016,
//     PumpTripped = 16017,
//     SludgeReturnPumpTripped = 16018,
//     LossofAirAlarm = 16019,
//     LossofAirAlarmBlower2 = 16020,
//     MotorTripped = 16021,
//     HighLevelGreaseAlaram = 16022,
//     CommonFault = 16023,
//     HighLevelOil = 16024,
//     HighSiltAlarm = 16025
// }

// #endregion

export class KingspanConfigurationFormService {

    // #region Consts    

    // private localizations: Record<string, Record<string, string>> = {
    //     'fr-FR': {
    //         'Common Alarm': 'Alarme commune',
    //         'Common Fault': 'Défaut commun',
    //         'Custom Alarm Details': 'Détails de l\'alarme personnalisée',
    //         'High Level Alarm': 'Alarme de haut niveau',
    //         'High Level Grease Alaram': 'Alaram de graisse de haut niveau',
    //         'High Level Oil': 'Huile de haut niveau',
    //         'High Silt Alarm': 'Alarme de haut niveau de limon',
    //         'Loss of Air Alarm Blower 2': 'Perte du souffleur d\'alarme d\'air 2',
    //         'Loss of Air Alarm': 'Alarme de perte d\'air',
    //         'Loss Of Power': 'Perte de puissance',
    //         'Loss of Power': 'Perte de puissance',
    //         'Loss Of Rotation': 'Perte de rotation',
    //         'Motor Tripped': 'Moteur déclenché',
    //         'Pump 1 Tripped': 'Pompe 1 déclenchée',
    //         'Pump 2 Tripped': 'Pompe 2 déclenchée',
    //         'Pump Tripped': 'Pompe déclenchée',
    //         'Sludge Return Pump Tripped': 'Déclenchement de la pompe de retour des boues',
    //     },

    //     default: {
    //         'Common Alarm': 'Common Alarm',
    //         'Common Fault': 'Common Fault',
    //         'Custom Alarm Details': 'Custom Alarm Details',
    //         'High Level Alarm': 'High Level Alarm',
    //         'High Level Grease Alaram': 'High Level Grease Alaram',
    //         'High Level Oil': 'High Level Oil',
    //         'High Silt Alarm': 'High Silt Alarm',
    //         'Loss of Air Alarm Blower 2': 'Loss of Air Alarm Blower 2',
    //         'Loss of Air Alarm': 'Loss of Air Alarm',
    //         'Loss Of Power': 'Loss Of Power',
    //         'Loss of Power': 'Loss of Power',
    //         'Loss Of Rotation': 'Loss Of Rotation',
    //         'Motor Tripped': 'Motor Tripped',
    //         'Pump 1 Tripped': 'Pump 1 Tripped',
    //         'Pump 2 Tripped': 'Pump 2 Tripped',
    //         'Pump Tripped': 'Pump Tripped',
    //         'Sludge Return Pump Tripped': 'Sludge Return Pump Tripped',
    //     }
    // }


    // #endregion

    // #region Ctor

    public constructor(private readonly userSession: UserSessionService) { }

    // #endregion

    // #region Options

    // public getLocationInstalationCategories(): { PumpStation: number, SewageTreatmentPlant: number, GreaseSeparators: number, OilSeparators: number, Custom: number } {
    //     return {
    //         PumpStation: 15740,
    //         SewageTreatmentPlant: 15741,
    //         GreaseSeparators: 15742,
    //         OilSeparators: 15743,
    //         Custom: 15744
    //     }
    // }

    public getKingspanDedicatedFormDataTypesList(): Enums.DataType[] {
        return [
            Enums.DataType.DEVICE_UDI_DESCRIPTION_1,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_2,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_3,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_4,
            Enums.DataType.DEVICE_UDO_CONFIGURATION,

            Enums.DataType.DEVICE_UDI_CONFIGURATION_1,
            Enums.DataType.DEVICE_UDI_CONFIGURATION_2,
            Enums.DataType.DEVICE_UDI_CONFIGURATION_3,
            Enums.DataType.DEVICE_UDI_CONFIGURATION_4,
            Enums.DataType.DEVICE_UDO_DESCRIPTION,

            Enums.DataType.DEVICE_UDI_ENABLED_1,
            Enums.DataType.DEVICE_UDI_ENABLED_2,
            Enums.DataType.DEVICE_UDI_ENABLED_3,
            Enums.DataType.DEVICE_UDI_ENABLED_4,
            Enums.DataType.ACTION_SCHEDULE_MODE,

            Enums.DataType.LOCATION_INSTALLATION_CATEGORY
        ]
    }

    public getKingspanDedicatedFormHiddenDataTypesList(): Enums.DataType[] {
        return [
            Enums.DataType.DEVICE_UDI_DESCRIPTION_1_ID_DESCR,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_2_ID_DESCR,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_3_ID_DESCR,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_4_ID_DESCR
        ]
    }

    public getDeviceUdiIds(): Enums.DataType[] {
        return [
            Enums.DataType.DEVICE_UDI_DESCRIPTION_1,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_2,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_3,
            Enums.DataType.DEVICE_UDI_DESCRIPTION_4
        ]
    }

    //#region Localization

    public isDescrInCommonInstallationCategoryRange(idDescr: number): boolean {
        return idDescr >= idCommonInstallationCategoryMin && idDescr <= idCommonInstallationCategoryMax
    }

    public isDescrInCommonUdiDescriptionRange(idDescr: number): boolean {
        return idDescr >= idCommonUdiDescriptionMin && idDescr <= idCommonUdiDescriptionMax
    }

    // public translateUDIDescriptions(formData: Record<string, string>): void {
    //     if (formData != null) {
    //         const UDIDescription1: string = formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1]

    //         if (UDIDescription1 != null) {
    //             formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1] = this.getMatchingTranslation(UDIDescription1)
    //         }

    //         const UDIDescription2: string = formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2]

    //         if (UDIDescription2 != null) {
    //             formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2] = this.getMatchingTranslation(UDIDescription2)
    //         }

    //         const UDIDescription3: string = formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3]

    //         if (UDIDescription3 != null) {
    //             formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3] = this.getMatchingTranslation(UDIDescription3)
    //         }

    //         const UDIDescription4: string = formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4]

    //         if (UDIDescription4 != null) {
    //             formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4] = this.getMatchingTranslation(UDIDescription4)
    //         }
    //     }
    // }

    /**
     * Returns a localized text in the current locale for the given text in, possibly, different locale.
     */
    // private getMatchingTranslation(text: string): string {
    //     const key: string = this.findLocalizationKey(text)

    //     if (key != null) {
    //         return this.getLocalization(key)
    //     }

    //     return null
    // }

    /**
     *  Returns the first matching localization key for the given localized text.
     */
    // private findLocalizationKey(text: string): string {
    //     let matchingKey: string = null

    //     _.forEach(this.localizations, (localizations: Record<string, string>) => {
    //         _.some(localizations, (localizedText: string, localizationKey: string) => {
    //             if (localizedText === text) {
    //                 matchingKey = localizationKey

    //                 return true
    //             }

    //             return false
    //         })

    //         if (matchingKey != null) {
    //             return true
    //         }

    //         return false
    //     })

    //     return matchingKey
    // }

    /**
     * Returns localizations for the current locale.
     */
    // private getLocalizations(): Record<string, string> {
    //     const language: string = this.userSession.getDataProvider().System.getCurrentLanguage()
    //     const localizations: Record<string, string> = this.localizations[language]

    //     if (localizations != null) {
    //         return localizations
    //     }

    //     return this.localizations['default']
    // }

    /**
     * Returns localization for the given key.
     */
    // private getLocalization(key: string): string {
    //     const localizations: Record<string, string> = this.getLocalizations()

    //     if (localizations != null && localizations[key] != null) {
    //         return localizations[key]
    //     }

    //     return null
    // }

    //#endregion


    //#region Input Name Lists

    // public getPumpStationList(udiDescriptions: OpDescr[]): { name: string, id: number }[] {
    //     const keys = [
    //         { name: 'High Level Alarm', id: KingspnaAlarms.HighLevelAlarm as number },
    //         { name: 'Loss Of Power', id: KingspnaAlarms.LossOfPower as number },
    //         { name: 'Pump 1 Tripped', id: KingspnaAlarms.Pump1Tripped as number },
    //         { name: 'Pump 2 Tripped', id: KingspnaAlarms.Pump2Tripped as number },
    //         { name: 'Common Alarm', id: KingspnaAlarms.CommonAlarm as number },
    //         { name: 'Custom Alarm Details', id: KingspnaAlarms.CustomAlarmDetails as number }
    //     ]

    //     return this.getLocalizedList(keys, udiDescriptions)
    // }

    // public getSewageTreatmentPlantList(udiDescriptions: OpDescr[]): { name: string, id: number }[] {
    //     const keys = [
    //         { name: 'High Level Alarm', id: KingspnaAlarms.HighLevelAlarm as number },
    //         { name: 'Loss Of Power', id: KingspnaAlarms.LossOfPower as number },
    //         { name: 'Loss Of Rotation', id: KingspnaAlarms.LossOfRotation as number },
    //         { name: 'Pump Tripped', id: KingspnaAlarms.Pump1Tripped as number },
    //         { name: 'Sludge Return Pump Tripped', id: KingspnaAlarms.SludgeReturnPumpTripped as number },
    //         { name: 'Loss of Air Alarm', id: KingspnaAlarms.LossofAirAlarm as number },
    //         { name: 'Loss of Air Alarm Blower 2', id: KingspnaAlarms.LossofAirAlarmBlower2 as number },
    //         { name: 'Common Alarm', id: KingspnaAlarms.CommonAlarm as number },
    //         { name: 'Motor Tripped', id: KingspnaAlarms.MotorTripped as number },
    //         { name: 'Custom Alarm Details', id: KingspnaAlarms.CustomAlarmDetails as number },
    //     ]

    //     return this.getLocalizedList(keys, udiDescriptions)
    // }

    // public getGreaseSeparatorsList(udiDescriptions: OpDescr[]): { name: string, id: number }[] {
    //     const keys = [
    //         { name: 'High Level Grease Alaram', id: KingspnaAlarms.HighLevelGreaseAlaram as number },
    //         { name: 'Loss Of Power', id: KingspnaAlarms.LossOfPower as number },
    //         { name: 'Common Fault', id: KingspnaAlarms.CommonFault as number },
    //         { name: 'Custom Alarm Details', id: KingspnaAlarms.CustomAlarmDetails as number },
    //     ]

    //     return this.getLocalizedList(keys, udiDescriptions)
    // }

    // public getOilSeparatorsList(udiDescriptions: OpDescr[]): { name: string, id: number }[] {
    //     const keys = [
    //         { name: 'High Level Oil', id: KingspnaAlarms.HighLevelOil as number },
    //         { name: 'High Silt Alarm', id: KingspnaAlarms.HighSiltAlarm as number },
    //         { name: 'Loss of Power', id: KingspnaAlarms.LossOfPower as number },
    //         { name: 'Custom Alarm Details', id: KingspnaAlarms.CustomAlarmDetails as number },
    //     ]

    //     return this.getLocalizedList(keys, udiDescriptions)
    // }

    public getDeviceUdiEnabledNumber(idDataType: Enums.DataType): number {
        switch (idDataType) {
            case Enums.DataType.DEVICE_UDI_ENABLED_1:
                return 1
            case Enums.DataType.DEVICE_UDI_ENABLED_2:
                return 2
            case Enums.DataType.DEVICE_UDI_ENABLED_3:
                return 3
            case Enums.DataType.DEVICE_UDI_ENABLED_4:
                return 4
            default: return -1
        }
    }

    public getDeviceUdiEnabledNumberByUdiDesciption(idDataType: Enums.DataType): number {
        switch (idDataType) {
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_1:
                return 1
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_2:
                return 2
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_3:
                return 3
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_4:
                return 4
            default: return -1
        }
    }

    // private getLocalizedList(keys: { name: string, id: number }[], udiDescriptions: OpDescr[]): { name: string, id: number }[] {
    //     if (_.size(udiDescriptions) > 0) {
    //         keys.forEach((key: { name: string, id: number }) => {
    //             const descr: OpDescr = _.find(udiDescriptions, ((item: OpDescr) => item.idDescr == key.id))

    //             if (descr != null) {
    //                 key.name = descr.description
    //             }
    //         })
    //     }

    //     return keys
    // }

    //#endregion

    // #endregion


    //#region Descriptions    

    public getUdiDescriptions(): JQueryPromise<OpDescr[]> {
        return this.userSession
            .getDataProvider()
            .System.getDictionaries([Enums.ReferenceType.IdDeviceUdiDescription], true)
            .then((result: Dictionary<Dictionary<IReferenceType>>) => {
                const descrDictionary: Dictionary<IReferenceType> = result.tryGetValue(Enums.ReferenceType.IdDeviceUdiDescription)
                return descrDictionary.values().map((item: IReferenceType) => item.getReferenceValue())
            })
    }

    public saveDescriptions(descriptionsList: OpDescr[]): JQueryPromise<OpDescr[]> {
        return this.userSession
            .getDataProvider()
            .Description
            .saveDescriptions(descriptionsList)
            .then((result: OpDescr[]) => {
                return result
            })
    }

    //#endregion

    //#region InstallationCategores

    public getCategoriesWithUdiDescriptions(): JQueryPromise<OpInstallationCategory[]> {
        return this.userSession
            .getDataProvider()
            .Location
            .getLocationInstallationCategory()
            .then((data: OpInstallationCategory[]) => {
                return data
            })
    }

    public saveInstallaTionCategory(toSave: OpInstallationCategory): JQueryPromise<OpInstallationCategory> {
        return this.userSession
            .getDataProvider()
            .Location
            .saveLOcationInstallationCategory(toSave)
            .then((data: OpInstallationCategory) => {
                return data
            })
    }

    //#endregion
}



export class KingspanConfigurationFormServiceProvider implements ng.IServiceProvider {

    // #region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSession: UserSessionService) {
        return new KingspanConfigurationFormService(userSession)
    }]

    // #endregion
}